// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5f512845","239":"24522008","455":"1cb8df57"}[chunkId] + ".chunk.js";
};